// extracted by mini-css-extract-plugin
export default {"people-view-title":"people_view_people-view-title__xGtRM"};